// #region imports

// --- Angular
import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-login-signup-branch',
  templateUrl: './login-signup-branch.component.html',
  styleUrls: ['./login-signup-branch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginSignupBranchComponent {
  @Output() login = new EventEmitter();
  @Output() register = new EventEmitter();

  private selectionMade: boolean;

  constructor() {
    this.selectionMade = false;
  }

  onLoginClicked(e: any): void {
    if (!this.selectionMade) {
      this.selectionMade = true;
      this.login.emit();
    }
  }

  onSignUpClicked(e: any): void {
    if (!this.selectionMade) {
      this.selectionMade = true;
      this.register.emit();
    }
  }
}
